var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2762 0H4.32736C3.59507 0 3 0.599733 3 1.3416V22.6584C3 23.3995 3.59507 24 4.32736 24H20.2591C20.993 24 21.5865 23.3995 21.5865 22.6584V5.3664L16.2762 0ZM16.2762 1.8968L19.7097 5.3664H16.2762V1.8968ZM20.2594 22.6584H4.32736V1.3416H14.9486V5.3664C14.9486 6.10747 15.5424 6.708 16.276 6.708H20.2591L20.2594 22.6584Z",
    fill: "#D2294B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12436_10957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.42284C15.9825 9.56443 15.4695 9.72175 14.9464 9.90379C14.7414 9.58465 14.4973 9.3217 14.2139 9.11494C13.767 8.78794 13.2416 8.625 12.639 8.625C11.8516 8.625 11.2176 8.92391 10.7371 9.52397C10.6105 9.68129 10.5007 9.85659 10.4089 10.0487C10.3518 10.1667 10.3025 10.2915 10.2577 10.4229L10.4089 8.81491H8.47001L7.5 19.125H9.43889L10.0449 12.6895L10.0852 12.2512C10.1938 11.6793 10.494 11.241 10.7438 10.9354C11.0552 10.5555 11.4584 10.3645 11.9546 10.3645C12.3568 10.3645 12.6961 10.487 12.975 10.7286C12.5304 10.9994 12.1395 11.3646 11.7609 11.7276C10.8379 12.6119 10.2342 14.2795 10.7281 15.5089C10.8726 15.8685 11.2445 16.3191 11.5335 16.4944C12.3142 16.9663 13.4757 16.8068 14.2139 16.2663C14.6608 15.9393 15.0103 15.474 15.2634 14.8695C15.5154 14.2649 15.642 13.539 15.642 12.6906C15.642 12.0849 15.5759 11.5422 15.4471 11.0612C15.7921 10.9039 16.1449 10.7634 16.5 10.6342V9.42284ZM13.4208 14.3649C13.2596 14.7504 12.9582 15.1414 12.4956 15.1167C12.3332 15.1088 12.1742 15.0313 12.098 14.8807C12.0431 14.7706 12.0319 14.6436 12.0353 14.52C12.0588 13.8278 12.4878 13.1974 12.975 12.7389C13.1834 12.5445 13.3973 12.3557 13.6191 12.1759C13.6359 12.3366 13.6449 12.5074 13.6449 12.6906C13.6449 13.4806 13.609 13.9098 13.4208 14.3649Z",
    fill: "#D2284B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12436_10957"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 10.5,
    fill: "white",
    transform: "translate(7.5 8.625)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf-icon.f4b44d68f5d98fe0f3776faefca796d0.svg";